"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetResponseSchema = exports.ConfirmResponseSchema = exports.ConfirmRequestSchema = exports.CustomOrderAttributesSchema = void 0;
const zod_1 = require("zod");
const image_1 = require("../common/image");
const order_full_1 = require("../common/order_full");
const order_item_full_1 = require("../common/order_item_full");
const product_1 = require("../common/product");
const product_item_full_1 = require("../common/product_item_full");
// Custom order schema for public order get. This order schema has additional
// Order->OrderItems->ProductItem->Product association whereas other the common
// order schemas do not. We cannot change ProductItem to include Product
// association by default since Product->ProductItems hierarchy is a much more
// popular schema hierarchy, e.g. products, productTypes, collections APIs.
exports.CustomOrderAttributesSchema = order_full_1.OrderAttributesFullSchema.merge(zod_1.z.object({
    OrderItems: zod_1.z
        .array(order_item_full_1.OrderItemAttributesFullSchema.merge(zod_1.z.object({
        ProductItem: product_item_full_1.ProductItemAttributesFullSchema.merge(zod_1.z.object({
            Product: product_1.ProductAttributesSchema.merge(zod_1.z.object({
                Images: zod_1.z
                    .array(image_1.ImageAttributesSchema)
                    .nullable()
                    .optional(),
            }))
                .nullable()
                .optional(),
        }))
            .nullable()
            .optional(),
    })))
        .nullable()
        .optional(),
}));
exports.ConfirmRequestSchema = zod_1.z.object({
    deliveryAddressInstructions: zod_1.z.string().optional(),
});
exports.ConfirmResponseSchema = zod_1.z.object({
    order: exports.CustomOrderAttributesSchema,
});
exports.GetResponseSchema = zod_1.z.object({
    order: exports.CustomOrderAttributesSchema,
});
//# sourceMappingURL=api.js.map